import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import $t from 'i18n'
import Card from 'components/common/Card'
import { gcpStorageUrl } from 'consts'
import { planExtraInfo } from 'consts/planConsts'
import { Button } from 'antd'
import Actions from 'actions'
import routes from 'consts/routes'
import { STEPS } from 'consts/flowConsts'
import { getPlanFileUrl } from 'utils/planUtils'
import Page from 'components/common/Page'
import ActionButton from 'components/common/ActionButton'
import { LAYOUT_TYPE } from 'consts'
import useApplicationValidation from 'hooks/useApplicationValidation'
import { captureScreenshot } from 'utils/planUtils'

import './ComparePlans.css'

const ComparePlans = () => {
  const dispatch = useDispatch()
  useApplicationValidation()

  const comparePlans = useSelector(state => state.plan?.comparePlans)

  const isBroker = useSelector(state => state.app.layout === LAYOUT_TYPE.broker)

  useEffect(() => {
    if (!comparePlans?.length) {
      dispatch(Actions.createAction(Actions.NAVIGATED_TO, routes.ENROLL_PLANS))
    }
  }, [])

  const onSeeDetails = plan => {
    dispatch(Actions.createAction(Actions.PLAN_SELECTED, { plan }))
    // navigate to plan details
    dispatch(
      Actions.createAction(
        Actions.NAVIGATED_TO,
        routes.ENROLL_PLAN?.replace(':planId', plan?.antidote_plan_id)
      )
    )
  }

  const onEnrollNow = plan => {
    // update selected plan
    dispatch(Actions.createAction(Actions.PLAN_SELECTED, { plan }))
    dispatch(
      Actions.createAction(Actions.STEP_COMPLETED, { step: STEPS.PLANS })
    )
  }

  const onComparePlanRemoved = plan => {
    dispatch(Actions.createAction(Actions.PLAN_COMPARE_REMOVED, { plan }))
  }

  const openShareQuoteDialog = async () => {
    const dataUrl = await captureScreenshot({
      classId: 'compare-plans-element'
    })

    dispatch(
      Actions.createAction(Actions.SHARE_QUOTE_DIALOG_OPENED, { dataUrl })
    )
  }

  const renderPlanCompareCard = plan => {
    // the title is what before the ()
    const nameSplit = plan?.translated_name?.split('(')
    const title = nameSplit?.[0]
    const planFileUrl = getPlanFileUrl(plan)
    const planDetails = plan?.translated_details

    return (
      <Card key={plan?.antidote_plan_id} className='compare-plan-card'>
        {comparePlans?.length > 2 && (
          <i
            className='close-icon icon-ex not-share-friendly'
            onClick={() => onComparePlanRemoved(plan)}
          />
        )}
        <div className='plan-header'>
          <img
            className='plan-img'
            alt=''
            crossOrigin='anonymous'
            src={`${gcpStorageUrl}/${planDetails?.color?.toLowerCase()}.svg`}
          />
          <div className='plan-title semi-bold'>{title}</div>
        </div>
        <div className='plan-field'>
          <div className='field-title'>
            {$t('enroll.plans.plan.monthlyPremium')}
          </div>
          <div className='field-value semi-bold plan-title'>
            ${plan?.plan_rate_multiplied}
          </div>
        </div>
        <div className='plan-field'>
          <div className='field-title'>
            {$t('enroll.plans.plan.annualDeductible')}
          </div>
          <div className='field-value'>{planDetails?.Annual_Deductible}</div>
        </div>
        <div className='plan-field'>
          <div className='field-title'>{$t('enroll.plans.plan.maxOop')}</div>
          <div className='field-value'>{planDetails?.Max_Out_of_Pocket}</div>
        </div>
        {planExtraInfo.map(field => (
          <div className='plan-field' key={field?.key}>
            <div className='field-title'>
              {$t(`enroll.plans.plan.extraInfo.${field?.key}`)}
            </div>
            <div className='field-value'>{planDetails?.[field?.value]}</div>
          </div>
        ))}
        <div className='plan-footer-buttons not-share-friendly'>
          <Button
            className='plan-enroll-btn'
            type='primary'
            onClick={() => onEnrollNow(plan)}
          >
            {$t('common.enrollNow')}
          </Button>
          <Button
            className='plan-details-btn'
            onClick={() => onSeeDetails(plan)}
          >
            {$t('common.seeDetails')}
          </Button>
          <Button
            className={
              planFileUrl ? 'plan-download-btn' : 'plan-download-btn hidden'
            }
            onClick={() => {
              window.open(planFileUrl, '_blank')
            }}
            type='link'
          >
            {$t('enroll.plans.plan.downloadDesc')}
          </Button>
        </div>
      </Card>
    )
  }

  return (
    <Page
      title={$t('dialogs.comparePlans.title')}
      className='compare-plans-page'
    >
      {isBroker && (
        <ActionButton
          className='plan-share-btn'
          icon={'icon-share'}
          onClick={openShareQuoteDialog}
        >
          {$t('common.share')}
        </ActionButton>
      )}
      <div className='compare-plans-wrapper' id='compare-plans-element'>
        {comparePlans?.map(renderPlanCompareCard)}
      </div>
    </Page>
  )
}

export default ComparePlans
